export const kds = {
	emptyKdsDescription:
		"O KDS ainda não foi criado. Quando disponível, será exibido aqui.",
	editKds: "As suas alterações foram salvas.",
	title: "Gerenciar KDS",
	subtitle: "Acesse e configure os KDS do seu estabelecimento aqui.",
	createdAt: "Criado em",
	seeKds: "Visualizar KDS",
	linkedBar: "Bar vinculado",
	basic: "Básico",
	main: "Principal",
	general: "Geral",
	mainTooltip:
		"O KDS Principal centraliza o controle de pedidos, permitindo alterar status, cancelar, visualizar cancelamentos e acompanhar todos os pedidos.",
	basicTooltip:
		"O KDS Básico mostra todos os pedidos direcionados a ele com status de aberto e concluído, sem permitir alterações ou visualização de cancelamentos.",
	confirmModal: {
		title: "Você tem alterações não salvas",
		description:
			"Para sair da página sem perder o progresso, salve suas alterações. Se continuar	sem salvar, todas as alterações serão perdidas.",
		close: "Sair sem salvar",
	},
	form: {
		name: "Nome do KDS",
		linkedBar: "Bar vinculado",
		status: "Troca de status",
		timeManagement: "Gestão de tempo",
		readyTimeOrderLabel: "Tempo por pedido ser considerado pronto",
		standardTimeOrderLabel: "Tempo padrão por pedido (min.)",
		originOrder: "Origem do pedido (Delivery e outras integrações)",
		orderNumber: "Número do pedido",
		customerName: "Nome do cliente",
		saveChanges: "Salvar alterações",
		generalSettings: "Configurações gerais",
		timeSettings: "Configurações de tempo",
		orderCardSettings: "Configurações do card de pedido",
	},
	statusChangeTypes: {
		auto: "Automaticamente",
		manual: "Manualmente",
	},
	timeManagementTypes: {
		byProduct: "Utilizar tempo por produto da integração",
		defaultTime: "Utilizar um padrão por pedido",
		noManagement: "Não utilizar tempo",
	},
	zigKds: {
		title: "Gestão de KDS",
		description: "Gerencie seus KDS, vincule produtos às telas e acompanhe pedidos.",
		searchPlaceholder: "Buscar por...",
		createNew: "Criar novo",
		card: {
			linkedBarLabel: "Bar(es) atrelado(s):",
			linkedProductsLabel: "Produtos Vinculados",
			editButton: "Editar",
			addScreenButton: "Adicionar tela",
			editScreen: "Editar tela",
			deleteScreen: "Excluir tela",
			primary: "Primário",
			secondary: "Secundário",
		},
		emptyState: {
			createNewKds: "Criar um novo KDS",
			title: "Nenhum KDS configurado ainda",
			description:
				"Você ainda não possui nenhum KDS. Cadastre e configure um para acompanhar seus pedidos em telas.",
			noSearchResults: {
				title: "KDS não encontrado",
				description:
					"Não encontramos nenhum KDS com os termos pesquisados. Tente ajustar sua busca.",
			},
		},
		deleteScreenModal: {
			title: "Excluir tela",
			confirmText:
				"Tem certeza de que deseja <highlight>excluir</highlight> a tela {{screenName}}?",
			warningText:
				"Ao confirmar, todos os produtos associados a esta tela serão excluídos.",
			cancelButton: "Voltar",
			confirmButton: "Confirmar",
		},
		drawer: {
			createTitle: "Criar novo KDS",
			editTitle: "Editar KDS",
			backButton: "Voltar",
			saveButton: "Salvar",
			deleteButton: "Excluir KDS",
		},
		deleteKdsModal: {
			title: "Excluir KDS",
			confirmText:
				"Tem certeza de que deseja <highlight>excluir</highlight> o KDS {{kdsName}}?",
			warningText:
				"Ao confirmar, todas as telas vinculadas e produtos associados a este KDS serão excluídas.",
			backButton: "Voltar",
			confirmButton: "Confirmar",
		},
		configForm: {
			kdsNameLabel: "Nome do KDS",
			kdsNamePlaceholder: "Descreva o nome do novo KDS",
			linkedBarsLabel: "Bar(es) vinculado(s)",
			linkedBarsPlaceholder: "Selecione um ou mais bar para vincular",
			productsDisplayedLabel: "Produtos exibidos",
			productsDisplayedDescription:
				"Lista de todos os produtos do bar que podem ser mostrados neste KDS.",
			emptyProductsTitle: "Nenhum produto exibido ainda",
			emptyProductsBullet1: "Cadastre produtos no bar vinculado para aparecerem aqui.",
			emptyProductsBullet2: "Vincule este KDS a um bar para carregar os produtos.",
			goToBarsButton: "Ir para bares e setores",
			products: "produtos",
		},
		tabs: {
			configuration: "Configuração",
			statusAndTime: "Status & Tempo",
		},
		generalSettings: {
			timeManagementTitle: "Gestão de tempo",
			statusUpdateTitle: "Atualização do status do pedido",
			cardInfoTitle: "Informações exibidas no card do pedido",
		},
		screensPanel: {
			configuredScreensLabel: "Telas configuradas",
			addScreenButton: "Adicionar tela",
			unsavedWarningTitle: "KDS Principal não Salvo",
			unsavedWarningMessage:
				"Para poder <strong>editar ou adicionar novas telas</strong>, você precisa <strong>salvar abaixo</strong> as configurações do KDS Principal.",
			productsLabel: "Produtos",
		},
		productsPreview: {
			searchPlaceholder: "Buscar por produto ou categoria",
			loadingMessage: "Carregando produtos...",
			noResultsMessage: "Nenhum produto encontrado para a busca.",
			noProductsMessage: "Nenhum produto encontrado para o bar selecionado.",
		},
		settings: {
			timeSettings: {
				timerEnabled: {
					label: "Cronômetro de tempo do pedido",
					description: "Conta o tempo do pedido desde a criação até ser finalizado.",
				},
				productionTimeEnabled: {
					label: "Tempo de produção por produto",
					description: "Exibe o tempo estimado de preparo de cada produto.",
				},
			},
			cardInfoSettings: {
				showOrderNumber: {
					label: "Número do pedido",
					description: "Mostra o identificador único do pedido.",
				},
				showOrigin: {
					label: "Origem",
					description: "Indica de onde o pedido foi feito (PDV, delivery, etc.).",
				},
				showOrderTime: {
					label: "Hora do pedido",
					description: "Exibe o horário em que o pedido foi criado",
				},
				showCustomerTable: {
					label: "Cliente/Mesa",
					description: "Mostra o nome do cliente ou o número da mesa.",
				},
				showProductionTimeCard: {
					label: "Tempo de produção por produto",
					description: "Mostra o tempo estimado de preparo de cada item.",
				},
				showObservation: {
					label: "Observação",
					description: "Exibe observações adicionais ao pedido.",
				},
			},
			statusModeOptions: {
				manual: {
					label: "Manual",
					description: "Permite avançar o status do pedido manualmente",
				},
				automatic: {
					label: "Automática",
					description: "Permite avançar o status do pedido após um tempo definido",
				},
			},
		},
		notifications: {
			kdsCreated: "KDS criado com sucesso",
			kdsEdited: "KDS editado com sucesso",
			kdsDeleted: "KDS deletado com sucesso",
			screenDeleted: "Tela deletada com sucesso",
		},
	},
	report: {
		title: "Relatório de produção",
		description: "Acompanhe a performance dos setores de produção, identifique gargalos e oportunidades de melhoria.",
		tabs: {
			overview: "Visão geral",
			products: "Produtos",
			orders: "Pedidos",
		},
		filters: {
			kds: "Filtrar por KDS",
			screen: "Filtrar por tela",
			source: "Filtrar por origem do pedido",
			category: "Filtrar por categoria do produto",
			product: "Filtrar por produto",
		},
		productsTable: {
			product: "Produto",
			category: "Categoria",
			quantity: "Quantidade",
			expectedTime: "Tempo esperado",
			actualTime: "Tempo médio de prod.",
			variation: "Variação",
			empty: "Nenhum dado encontrado para o período selecionado.",
			error: "Erro ao carregar os dados. Tente novamente.",
		},
		overviewPlaceholder: {
			title: "Estamos preparando tudo por aqui!",
			description: "Em breve você poderá visualizar gráficos para analisar tempos de produção, atrasos etc.",
		},
	},
};
